const s = {
  name: "WifiReset",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.6 38" style="enable-background:new 0 0 39.6 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19.8,2C12.6,2,6.1,4.9,1.4,9.6L0,8.2C5.1,3.1,12.1,0,19.8,0s14.7,3.1,19.8,8.2l-1.4,1.4
			C33.5,4.9,27,2,19.8,2z"/>
		<path class="st0" d="M19.8,8c-5.5,0-10.5,2.2-14.1,5.9l-1.4-1.4c4-4,9.5-6.4,15.6-6.4c6.1,0,11.6,2.5,15.6,6.4l-1.4,1.4
			C30.3,10.2,25.3,8,19.8,8z"/>
		<path class="st0" d="M9.9,18.1c2.5-2.5,6-4.1,9.9-4.1s7.4,1.6,9.9,4.1l1.4-1.4c-2.9-2.9-6.9-4.7-11.3-4.7s-8.4,1.8-11.3,4.7
			L9.9,18.1z"/>
		<path class="st0" d="M14.1,22.3c1.4-1.4,3.4-2.3,5.7-2.3s4.2,0.9,5.7,2.3l1.4-1.4c-1.8-1.8-4.3-2.9-7.1-2.9s-5.3,1.1-7.1,2.9
			L14.1,22.3z"/>
		<path class="st0" d="M12.8,31c0-3.9,3.1-7,7-7s7,3.1,7,7s-3.1,7-7,7v-2c2.8,0,5-2.2,5-5s-2.2-5-5-5s-5,2.2-5,5v1.6l2.3-2.3
			l1.4,1.4l-4.7,4.7l-4.7-4.7l1.4-1.4l2.3,2.3V31z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as WifiReset
};
